
import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-regional-sales',
  templateUrl: './regional-sales.component.html',
  styleUrls: ['./regional-sales.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class RegionalSalesComponent {
  @Input() dashboardData: any;
  regionalSalesData: any;
  nationalWeekly: any;
  nationalLastYearYtdSales: any;
  nationalVarience: any;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      const nationalSales = this.dashboardData?.national_sales;
      const areaShopSales = this.dashboardData?.area_shops_sales;
      // console.log(areaShopSales)
      this.nationalWeekly = nationalSales.sum_thisweek_sales;
      this.nationalLastYearYtdSales = nationalSales.sum_last_year_ytd_sales;
      this.nationalVarience = nationalSales.sum_varience_sales;
      // Map areaShopSales to regionalSalesData with calculated varPercent
      this.regionalSalesData = (areaShopSales || []).map((shop: any) => {
        const thisYear = parseFloat(shop.ytd_sales) || 0;
        const lastYear = parseFloat(shop.last_year_ytd_sales) || 0;
        let varPercent = 0;
        if (lastYear === 0 && thisYear > 0) {
          varPercent = 100;
        } else if (lastYear === 0 && thisYear === 0) {
          varPercent = 0;
        } else {
          varPercent = ((thisYear - lastYear) / Math.abs(lastYear)) * 100;
        }
        return {
          name: shop.name,
          thisYear,
          lastYear,
          varPercent: isFinite(varPercent) ? varPercent : 0
        };
      });
    }
  }
}
